import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { CurrencyPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseCardComponent } from '@fuse/components/card';
import { Meta, Title } from '@angular/platform-browser';
import { BannerSectionType01Component } from '../../banner-section/banner_section-type01/banner_section-type01.component';


@Component({
    selector: 'app-packages-type03',
    standalone: true,
    imports: [
        MatIconModule,
        CurrencyPipe,
        MatTooltipModule,
        RouterLink,
        FuseCardComponent,
        BannerSectionType01Component,
        NgFor,
        NgIf,
        NgClass
    ],
    templateUrl: './packages-type03.component.html',
    styleUrl: './packages-type03.component.scss',
})
export class PackagesType03Component implements OnInit {

   public view: any = {
        searchQuery: '',
        filteredBundles: [],
        destination: {},
        selectedRegions: [],
        packageImageUrl: 'assets/images/xl-travel-banners/XL_WEB_PAGE_BANNERS_2.jpg',
        isLoading: true,
        isError: false,
        selectedRegion: 'All Destinations'
    };

    public optimaRail = [
   {
    region: 'Europe',
    subsections: [
      {
        title: 'High Speed Rail',
        description: 'Rapid, comfortable intercity travel',
        services: [
          {
            title: 'Eurostar',
            country: 'UK to Europe',
            image: 'assets/images/rail/europe/EUROSTAR.png'
          },
          {
            title: 'AVE',
            country: 'Spain',
            image: 'assets/images/rail/europe/ave spain.jpg?v=2'
          },
          {
            title: 'ICE',
            country: 'Germany',
            image: 'assets/images/rail/europe/ice.jpg?v=3'
          },
          {
            title: 'TGV',
            country: 'France',
            image: 'assets/images/rail/europe/tvg.jpg?v=3'
          }
        ]
      },
      {
        title: 'Scenic & Regional Trains',
        description: '',
        services: [
          {
            title: 'Bernina Express',
            country: 'Switzerland – Italy',
            image: 'assets/images/rail/europe/Bernina Express.jpg?v=3'
          },
          {
            title: 'InterCity Express',
            country: 'Germany',
            image: 'assets/images/rail/europe/Intercity Germany.png?v=1'
          },
          {
            title: 'Railjet',
            country: 'Austria',
            image: 'assets/images/rail/europe/railjet.jpg?v=3'
          }
        ]
      },
      {
        title: 'Luxury & Heritage Trains',
        description: '',
        services: [
          {
            title: 'Orient-Express',
            country: 'Venice Simplon',
            image: 'assets/images/rail/europe/Venice Simpion.jpg?v=2'
          },
          {
            title: 'Golden Pass Line',
            country: '',
            image: 'assets/images/rail/europe/goldenpass-express-lavaux.png?v=2'
          },
          {
            title: 'Royal Scotsman',
            country: '',
            image: 'assets/images/rail/europe/Royal Scotsman.jpg?v=2'
          }
        ]
      },
      {
        title: 'Rail Passes',
        description: 'BritRail Passes for unlimited travel across England, Scotland, and Wales.',
      }
    ]
  },
  {
    region: 'North America',
    subsections: [
      {
        title: 'USA',
        description: 'Fast travel; scenic routes like the Californian Zephyr & Coast Starlight.',
        services: [
          {
            title: 'Amtrak\'s',
            country: 'Express',
            image: 'assets/images/rail/north america/Amtrak’s Acela Express.jpg?v=1'
          },
          {
            title: 'Northeast Regional',
            country: '',
            image: 'assets/images/rail/north america/Northeast Regional.jpg?v=1'
          },
        ]
      },
      {
        title: 'Canada',
        description: 'Cross-country travel & luxury journeys like the Rocky Mountaineer and The Canadian.',
        services: [
          {
            title: 'Rocky Mountaineer',
            country: '',
            image: 'assets/images/rail/north america/Rocky_Mountaineer_Onboard_GoldLeaf_Service_Host.jpg?v=1'
          },
          {
            title: 'The Canadian',
            country: '',
            image: 'assets/images/rail/north america/The Canadian.jpg?v=1'
          },
        ]
      },
      {
        title: '',
        description: '',
      }
    ]
  },
  {
    region: 'Peru',
    subsections: [
      {
        title: '',
        description: 'Embark on an unforgettable journey to Machu Picchu.',
        services: [
          {
            title: 'Hiram Bingham',
            country: '',
            image: 'assets/images/rail/peru/Hiram Bingham.jpg?v=1'
          },
        ]
      },
    ]
  },
  {
    region: 'India',
    subsections: [
      {
        title: '',
        description: 'Experience royalty and pure luxury.',
        services: [
          {
            title: 'Deccan Odyssey',
            country: '',
            image: 'assets/images/rail/india/Deccan Odyssey.jpg?v=1'
          },
          {
            title: 'Maharaja\'s',
            country: '',
            image: 'assets/images/rail/india/Maharajas Express.jpg?v=1'
          },
        ]
      },
    ]
  },
  {
    region: 'Australia',
    subsections: [
      {
        title: 'Cross-country Rail',
        description: 'Immersive experiences across the Outback.',
        services: [
          {
            title: 'The Ghan',
            country: '',
            image: 'assets/images/rail/australia/The Ghan.png?v=1'
          },
          {
            title: 'Indian Pacific',
            country: '',
            image: 'assets/images/rail/australia/Indian Pacific.jpg?v=1'
          },
        ]
      },
    ]
  },
  {
    region: 'Japan',
    subsections: [
      {
        title: '',
        description: 'Bullet trains connecting major cities.',
        services: [
          {
            title: 'Shinkansen',
            country: '',
            image: 'assets/images/rail/japan/Shinkansen bullet.jpg?v=1'
          },
        ]
      },
    ]
  },
  {
    region: 'SE Asia',
    subsections: [
      {
        title: '',
        description: 'Luxurious journey through Malaysia and Thailand',
        services: [
          {
            title: 'Eastern & Oriental Express',
            country: '',
            image: 'assets/images/rail/se asia/Eastern & Oriental Express.jpg?v=1'
          },
        ]
      },
    ]
  },
];
    // regions: string[] = [];

    constructor(
        public tfmService: TFMService,
        private route: ActivatedRoute,
        private title: Title,
        private metaService: Meta,
        private _cd: ChangeDetectorRef
    ) {

    }

    startSlideshow(): void {
        setInterval(() => {
            const nextIndex = (this.view.currentImageIndex + 1) % this.view.imageHrefs.length;
            const nextImage = this.view.imageHrefs[nextIndex];

            this.fadeToImage(nextImage);
            this.view.currentImageIndex = nextIndex;
        }, 5000);
    }

    fadeToImage(nextImage: string): void {
        const img = new Image();
        img.src = nextImage;

        img.onload = () => {
            if (this.view.activeLayer === 1) {
                this.view.imageLayer2 = nextImage;
                this.view.activeLayer = 2;
            } else {
                this.view.imageLayer1 = nextImage;
                this.view.activeLayer = 1;
            }
            this._cd.detectChanges();
        };
    }

    ngOnInit(): void {
        this.view.isLoading = true;
        this.view.isError = false;

        this.tfmService.getSite().then(res => {
            this.view.site = res;

            this.view.site.profile = this.tfmService.getSiteProfile(this.view.site.profileID);
            this.tfmService.log("Rail Site view", this.view.site);
        });

        this.view.currentImageIndex = 0;
        this.view.activeLayer = 1;
        this.view.imageLayer1 = ''; // start blank or with a default image
        this.view.imageLayer2 = '';

        this.tfmService.getContentBySection('rail').then((res) => {
            this.view.page = res;
            this.tfmService.log('Channel Section View: ', res);
            const images = this.view.page?.content?.images;

            if (images && images.length > 0) {
                this.view.imageHrefs = images
                    .map((img: any) => {
                        const viewLink = img._links?.find((link: any) => link.rel === 'view');
                        return viewLink?.href ?? null;
                    })
                    .filter((href: string | null) => href !== null);

                this.view.imageLayer1 = this.view.imageHrefs[0];
                this.startSlideshow();
            }
        });

        this.route.params.subscribe((params) => {
            this.view.id = params['id'];

            // Load destinations and bundles in parallel
            Promise.all([
                this.loadDestinations(),
                this.loadBundles()
            ])
                .then(() => {
                    this.getAdditionalContent();
                })
                .catch(error => {
                    this.view.isError = true;
                    this.view.isLoading = false;
                    console.error('Error loading data:', error);
                });
        });

        this.setMetaTags();
    }

    private loadDestinations(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.tfmService.getAllDestinations().subscribe({
                next: (res: any) => {
                    const uniqueNames = new Set<string>();
                    const filtered = res.content.filter((item: any) => {
                        if (!uniqueNames.has(item.name)) {
                            uniqueNames.add(item.name);
                            return true;
                        }
                        return false;
                    });

                    this.view.destinations = filtered;

                    const match = this.view.destinations.find(
                        d => d.id && String(d.id) === String(this.view.id)
                    );

                    if (match) {
                        this.view.destination = match;

                        if (match.metaData) {
                            this.view.destination.metaDataParsed = JSON.parse(match.metaData);
                        }

                        this.view.selectedRegion = match.name;
                    } else {
                        this.view.selectedRegion = 'All Destinations';
                    }

                    resolve();
                },
                error: (err) => {
                    console.error('Error loading destinations:', err);
                    this.view.isError = true;
                    reject(err);
                }
            });
        });
    }

    private loadBundles(): Promise<void> {

        const railTags = ['Blue Train', 'rovos, rovos rail'];

        return this.tfmService.filterBundles(
            {
                rateType: 'pps',
                onlyActive: true,
                contentId: this.view.id,
            },
            false
        ).then((res) => {
            this.view.bundles = res.content;
            this.view.railBundles = res.content.filter(bundle =>
                railTags.includes(bundle.tags)
            );
            this.tfmService.log('View Bundles: ', this.view.railBundles);

            this.view.railBundles.sort(
                (a, b) => a.priceAdvertise - b.priceAdvertise
            );
        }).catch(error => {
            console.error('Error loading bundles:', error);
            throw error; // Re-throw to be caught in the main catch
        });
    }

    getAdditionalContent() {
        if (this.view.type == 'destination-deals' ||
            this.view.type == 'experience-deals' ||
            this.view.type == 'article') {

            this.tfmService.filterBundles(
                {
                    rateType: 'pps',
                    onlyActive: true,
                    contentId: this.view.id,
                },
                false
            )
                .then((res) => {
                    this.view.bundles = res.content;
                    this.view.isLoading = false;
                })
                .catch(error => {
                    this.view.isError = true;
                    this.view.isLoading = false;
                    console.error('Error loading additional content:', error);
                });
        } else {
            // If no additional content needed, ensure loading is stopped
            this.view.isLoading = false;
        }
    }

    private setMetaTags(): void {
        this.title.setTitle(`Exclusive Travel Packages`);
        this.metaService.updateTag({
            name: 'description',
            content: 'Discover a world of travel packages with XL Travel. Explore adventure trips, family holidays, and honeymoon escapes with exclusive deals to make every journey unforgettable!',
        });
        this.metaService.updateTag({
            name: 'keywords',
            content: 'travel packages, exclusive travel deals, vacation packages, holiday packages, all-inclusive travel deals',
        });
    }

    onSearchQueryChange(event: any) {
        this.view.searchQuery = event.target.value.toLowerCase();
        this.filterDestinations();
    }

    filterDestinations(): void {
        if (!this.view.bundles) return;

        const selectedRegion = this.view.selectedRegion?.toLowerCase();
        const searchQuery = this.view.searchQuery?.toLowerCase();

        this.view.filteredBundles = this.view.bundles.filter((bundle) => {
            // Region matching
            const matchesRegion = (this.view.selectedRegion === 'All Destinations' || !this.view.selectedRegion)
                ? true
                : (
                    bundle.destination?.toLowerCase().includes(selectedRegion) ||
                    bundle.name?.toLowerCase().includes(selectedRegion) ||
                    bundle.destinationName?.toLowerCase().includes(selectedRegion) ||
                    bundle.tags?.toLowerCase().includes(selectedRegion)
                );

            // Search query matching
            const matchesSearchQuery = searchQuery
                ? (
                    bundle.name?.toLowerCase().includes(searchQuery) ||
                    bundle.destination?.toLowerCase().includes(searchQuery) ||
                    bundle.tags?.toLowerCase().includes(searchQuery)
                )
                : true;

            return matchesRegion && matchesSearchQuery;
        });
    }

    onRegionSelect(regionName: string) {
        this.view.selectedRegion = regionName;

        const query = regionName.toLowerCase();

        this.view.filteredBundles = this.view.bundles?.filter((b: any) => {
            const destinationName = b.destinationName?.toLowerCase() ?? '';
            const bundleName = b.name?.toLowerCase() ?? '';
            const tags = b.tags?.toLowerCase() ?? '';

            const inDestination = regionName === 'All Destinations' || destinationName.includes(query);

            const inName = bundleName.includes(query);

            const inTags = tags.includes(query);

            return inDestination || inName || inTags;
        });

        this.filterDestinations();
        console.log('Bundles', this.view.filteredBundles);
    }

    resetDestinationFilter(): void {
        this.view.selectedRegion = 'All Destinations';
        this.view.searchQuery = '';
        this.filterDestinations();
    }

    slugify(text: string): string {
        return text
            .toLowerCase()
            .trim()
            .replace(/[\s\W-|]+/g, '-');
    }
    resetFilters(): void {
        this.view.selectedRegion = 'All Destinations';
        this.view.searchQuery = '';
        this.view.filteredBundles = [...this.view.bundles];

    }
    hasActiveFilters(): boolean {
        return (this.view.selectedRegion !== 'All Destinations' && !!this.view.selectedRegion) ||
            !!this.view.searchQuery;
    }
}